/* eslint-disable */
const mutations = {
  getUserInfo(state, userInfo) {
    state.userInfo = userInfo
  }
}
export default mutations
